

import React, { useState, createContext } from 'react';
export const LoginContext = createContext({});